<template>
  <button type="submit" class="white_btn" :disabled="loading">
    <slot v-if="!loading"></slot>
    <LoaderEditProfile v-else />
  </button>
</template>

<script>
import LoaderEditProfile from "@/UI/Loaders/LoaderEditProfile.vue";

export default {
  name: "WhiteButton",
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    LoaderEditProfile,
  },
};
</script>

<style>
.white_btn {
  background: var(--edit-profile-submit);
  color: black;
  border-radius: 15px;
  padding: 8px 16px;
  height: 34px;
  width: 120px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.white_btn:hover {
  background-color: var(--edit-profile-submit-hover);
}

.white_btn:disabled {
  opacity: 60%;
  cursor: default;
}

.white_btn:disabled:hover {
  background: var(--edit-profile-submit);
}
</style>
